export default "__VITE_ASSET__bd4b5b9b__"